module.exports = __webpack_public_path__ + "media/images/icons/outlined/thunderbolt-02cca0d2385992e36030c37702ad7b64.svg";